import Styled from "styled-components";

export const Form = Styled.form``;

export const H1 = Styled.h1``;

export const ContainerCadastro = Styled.div``;

export const Input = Styled.input``;

export const Text = Styled.div``;

export const Line = Styled.div``;

export const RegisterNewAddress = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const AddressCard = Styled.div`
  position: relative;
  display: flex;
  gap: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
`;

export const AddressCardLock = Styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddressCardRadio = Styled.div`
  flex-shrink: 0;
  padding-top: 2px;

  input[type="radio"] {
    accent-color: ${(props) =>
      props.theme.whitelabel?.theme?.text_primary_color || "#050922"};
    width: 16px;
    height: 16px;
    cursor: default;
  }
`;

export const AddressCardContent = Styled.div`
  flex: 1;
  min-width: 0;
`;

export const AddressCardLabel = Styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin: 0 0 8px;
  padding-right: ${(props) => (props.$hasLock ? "28px" : "0")};
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
`;

export const AddressCardLine = Styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
`;

export const PrincipalBadge = Styled.span`
  box-sizing: border-box;
  display: inline-flex;
  width: 88.941px;
  min-height: 28px;
  padding: var(--spacing-8, 6.588px) var(--spacing-16, 13.176px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-none, 0);
  background: #f5f5f7;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  white-space: nowrap;
  color: ${(props) =>
    props.theme.whitelabel?.theme?.text_primary_color || "#050922"};
  flex-shrink: 0;
`;

export const AddressCardActions = Styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 12px;
`;

export const FixedAddressNote = Styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  font-style: italic;
  line-height: 150%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
`;

export const Registration = Styled.p``;

export const ContainerInput = Styled.div``;

export const Label = Styled.label``;

export const InputIEnjoy = Styled.input``;

export const InputLarge = Styled.input``;

export const ContainerInputDate = Styled.div``;

export const InputDate = Styled.input``;

export const InputMask = Styled.input``;

export const ConfirmAndCancel = Styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .cancel {
    color: #b00020;
  }
`;

export const RegisteredCards = Styled.div``;

export const CheckboxContainer = Styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Radio = Styled.input``;

export const FormContainer = Styled.div`
  .form-address__input {
    font-size: 14px !important;
    color: ${(props) =>
      props.theme.whitelabel?.theme?.text_primary_color} !important;
    border-bottom: 1px solid
      ${(props) => props.theme.whitelabel?.theme?.text_primary_color} !important;

    &:focus {
      border-bottom-color: ${(props) =>
        props.theme.whitelabel?.theme?.text_primary_color} !important;
    }
  }
`;